import { QuestionReviewTaskDetail } from '@exam-management/new-question-review-task-creation';
import { Flex } from '@shared/components';

export default function QuestionReviewTaskCreationPage() {
  return (
    <Flex sx={{ flexDirection: 'column', p: (theme) => theme.spacing(6) }}>
      <QuestionReviewTaskDetail />
    </Flex>
  );
}
